import React, { useState, useCallback } from "react";
import { Sidebar } from "../../components/Sidebar";
import { useLuniShowerHotels } from "../../components/LuniShower/hooks/useLuniShowerHotels";
import LuniShowerPageHeader from "../../components/LuniShower/Home/LuniShowerPageHeader";
import LuniShowerHotelsTable from "../../components/LuniShower/Home/LuniShowerHotelsTable";
import DescriptionModal from "../../components/Home/DescriptionModal";
import { LoadingState, ErrorState } from "../../components/UI";

const LuniShowerHome = () => {
  const { hotels, loading, loadingStats, statsPendingIds, error, searchTerm, setSearchTerm, updateHotelStatus, fetchHotels, sortState, handleSort } = useLuniShowerHotels();
  const [descriptionModal, setDescriptionModal] = useState({
    isOpen: false,
    hotel: null,
  });

  // Handlers stables : ils descendent jusqu'aux lignes mémoïsées.
  const handleEditDescription = useCallback((hotel) => {
    setDescriptionModal({ isOpen: true, hotel });
  }, []);

  // `fetchHotels` ne prend aucun argument : l'ancien `debouncedSearchTerm` n'était jamais
  // renvoyé par le hook et valait donc toujours undefined.
  const handleDescriptionSuccess = useCallback(() => {
    fetchHotels();
  }, [fetchHotels]);

  const closeDescriptionModal = useCallback(() => setDescriptionModal({ isOpen: false, hotel: null }), []);

  // États de chargement et d'erreur
  if (loading) {
    return <LoadingState message="Chargement des hôtels LuniShower..." />;
  }

  if (error) {
    return <ErrorState error={error} />;
  }

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 p-4 overflow-auto">
        <LuniShowerPageHeader />
        <LuniShowerHotelsTable hotels={hotels} onUpdateStatus={updateHotelStatus} onEditDescription={handleEditDescription} sortState={sortState} onSort={handleSort} loadingStats={loadingStats} statsPendingIds={statsPendingIds} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <DescriptionModal isOpen={descriptionModal.isOpen} onClose={closeDescriptionModal} hotel={descriptionModal.hotel} onSuccess={handleDescriptionSuccess} />
      </div>
    </div>
  );
};

export default LuniShowerHome;
